import React from "react";
import EmptyState from "../../../../common/components/xepp/empty-state/EmptyState";
import Card from "../../../../common/components/xepp/card/card";
import Button from "../../../../common/components/xepp/button/Button";
import { EmptyCountryIcon } from "../../../../assets/icons";
import styles from "./SettingsPage.module.scss";
import utilCardStyles from "../../../../common/components/xepp/utility-card/UtilityCard.module.scss";
import { Country } from "../../../../model/bill-settings/bill-settings";
import CommonLoadingSpinner from "../../../../common/components/loading-spinner/CommonLoadingSpinnerForPage";


interface CountryTabProps {
	isLoading: boolean;
	countries: Array<Country>;
	onSelectCountry: (id : number) => void;
}

const CountryTab: React.FC<CountryTabProps> = ({ isLoading, onSelectCountry, countries }) => {

	if (countries.length === 0) {
		return (
			<CommonLoadingSpinner loading={isLoading}>
			<div className={styles.emptyStateContainer}>
				<EmptyState
					icon={<EmptyCountryIcon className="mb-8" />}
					// title="Empty Country list"
					description="No countries listed"
					// button={{
					// 	text: "Add Country",
					// 	onClick: onSelectCountry,
					// 	type: "primary",
					// }}
				/>
			</div>
			</CommonLoadingSpinner>
		);
	}

	return (
		<div className={utilCardStyles.utilityGrid}>
			<CommonLoadingSpinner loading={isLoading}>
			{countries.map(country => (
				<Card key={country.id} className={styles.countryCard}>
					<div className={styles.cardContent}>
						<img src={country.imageUrl} alt={`${country.name} flag`} className={styles.countryFlag} />
						<div className={styles.cardBase}>
							<h3 className={styles.countryName}>{country.name}</h3>
							<Button text="Manage" variant="outline" onClick={() => onSelectCountry(country.id)} />
						</div>
					</div>
				</Card>
			
			))}
			</CommonLoadingSpinner>
		</div>
	);
};

export default CountryTab;
